import { useEffect, useRef } from "react";
import type { HomeViewMode } from "shared";
import { setMixpanelPeopleProperties } from "utilz/helpers";
import { trackAiHome } from "./aiHomeEvents";
import { isFirstAiHomeVisit } from "./aiHomeSession";

export const useAiHomeScreenView = ({
  mode,
  isResolving,
}: {
  mode: HomeViewMode;
  isResolving: boolean;
}) => {
  const trackedMode = useRef<HomeViewMode | null>(null);

  useEffect(() => {
    if (isResolving || trackedMode.current === mode) return;

    trackedMode.current = mode;
    trackAiHome("ai_home_screen_viewed", {
      screen_mode: mode,
      is_first_visit: isFirstAiHomeVisit(),
    });

    if (mode === "ai") {
      setMixpanelPeopleProperties({
        onceProperties: { first_ai_home_view_at: new Date().toISOString() },
      });
    }
  }, [isResolving, mode]);
};
